import { PanelState } from "@/shared/state/visualization";

import { PanelTitle } from "./PanelTitle";
import { SettingsSection } from "./SettingsSection";

interface BasePanelSettingsProps extends React.PropsWithChildren {
  state: PanelState;
}

export function BasePanelSettings({ state, children }: BasePanelSettingsProps) {
  return (
    <div>
      <SettingsSection title="General">
        <PanelTitle state={state} />
      </SettingsSection>
      {children}
    </div>
  );
}
